import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { height, Stack } from "@mui/system";
import {
  ButtonWrapper,
  CloseButton,
  CloseButtonWrapper,
  Content,
  Description,
  Divider,
  Header,
  InstructionWrapper,
  ModalWrapper,
  Title,
} from "../style/modalStyle";
import CustomButton from "./CustomButton";
import { DownArrowIconBlueLIne } from "../../assets/Icon/ArrowIcon";
import { CrossIcon } from "../../assets/Icon/ModalIcon";
import { Box } from "@mui/material";

interface InstructionSet {
  title?: string;
  heading?: string; // Optional property
  instructions?: string[];
}
interface ModalPropType {
  open: boolean;
  handleClose: () => void;
  data?: InstructionSet[];
  title?: string;
  desc?: string;
  isSs4?: boolean;
}

export default function CustomModal(props: ModalPropType) {
  const { open, handleClose, data, title, desc, isSs4 } = props;

  return (
    <>
      <Modal
        sx={{}}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <ModalWrapper sx={{}}>
          <CloseButtonWrapper>
            <CloseButton onClick={handleClose}>
              <CrossIcon />
            </CloseButton>
          </CloseButtonWrapper>
          <Header>
            <DownArrowIconBlueLIne />
            <Typography
              sx={{
                fontSize: "30px",
                fontWeight: 700,
              }}
            >
              {title}
              {/* Signature Instruction */}
            </Typography>
          </Header>
          <Divider />

          <Content sx={{ height: isSs4 ? "auto" : "300px", overflowY: "auto" }}>
            {data?.map((item, index) => (
              <InstructionWrapper key={index}>
                <Stack spacing={1.5}>
                  <Title>{item.title}</Title>
                  {item.heading && (
                    <Typography
                      sx={{ fontSize: "18px", fontWeight: 600, paddingY: 2 }}
                    >
                      {item.heading}
                    </Typography>
                  )}
                  {(item?.instructions ?? []).map((instruction, idx) => (
                    // <Box key={idx}>
                    <Description key={idx}>
                      {" "}
                      <Box>{`${idx + 1}. `}</Box>
                      <Box>{instruction}</Box>
                    </Description>
                    // </Box>
                  ))}
                </Stack>
              </InstructionWrapper>
            ))}
            <Typography sx={{ fontSize: "20px", fontWeight: 600, padding: 2 }}>
              {desc}
            </Typography>
          </Content>
          <ButtonWrapper onClick={handleClose}>
            <CustomButton btnTitle="Ok" minwidth="196px" />
            {/* <CustomButton btnTitle="Ok" minwidth="196px" /> */}
          </ButtonWrapper>
        </ModalWrapper>
      </Modal>
    </>
  );
}
